import React from "react";

export default function Layout({ children }) {
  return (
    <div className="max-w-[90rem] mx-auto px-4 sm:px-6 md:px-8 ">
      {children}
    </div>
  );
}
